import { EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  number_page: number;
  size_page: number;
  @Output() eventEmmiterChangePage: EventEmitter<number> = new EventEmitter<number>();
  @Input() total = 0;
  @Input() pages_total: number;
  pages: any[] = [];
  pages_totales: number[] = [];
  constructor() {
    this.number_page = 1;
    this.size_page = 11;

  }

  ngAfterViewInit() {


  }
  ngOnInit(): void {


  }
  ngOnChanges(changes: any) {
    this.pages_totales = [];
    for (let i = 0; i < this.pages_total; i++) {

      this.pages_totales.push(i + 1);


    }
    this.move(1);
  }

  move(number_page: number): void {
    this.pages = [];
    const delta = 2; // Cuántas páginas a cada lado del número actual
    const range: (number | string)[] = [];
    const total = this.pages_total;
  
    const left = Math.max(2, number_page - delta);
    const right = Math.min(total - 1, number_page + delta);
  
    range.push(1); // Siempre mostramos la primera página
  
    if (left > 2) {
      range.push('...');
    }
  
    for (let i = left; i <= right; i++) {
      range.push(i);
    }
  
    if (right < total - 1) {
      range.push('...');
    }
  
    if (total > 1) {
      range.push(total); // Siempre mostramos la última página si hay más de una
    }
  
    this.pages = range;
  }

  previus() {
    if (this.number_page > 1) {
      this.number_page = this.number_page - 1;
      this.eventEmmiterChangePage.emit(this.number_page);
      this.move(this.number_page);
    }

  }

  next() {
    if (this.number_page < this.pages_total) {
      this.number_page = this.number_page + 1;
      this.eventEmmiterChangePage.emit(this.number_page);
      this.move(this.number_page);
    }
  }
  cambiarPagina(number_page) {
    this.number_page = number_page;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page);

  }
  first() {
    this.number_page = 1;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page);



  }
  last() {
    this.number_page = this.pages_total;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page - 3);

  }
}
